module.exports = "<p-growl [(value)]=\"msgs\"></p-growl>\r\n<div style=\"color: green;\">הכנת פרטי תשלום הצליחה, נא להמתין...</div>"


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/tip-card-change/TripPaymentCardsDetailsVFSuccess/TripPaymentCardsDetailsVFSuccess.component.html
// module id = ../../../../../src/app/tip-card-change/TripPaymentCardsDetailsVFSuccess/TripPaymentCardsDetailsVFSuccess.component.html
// module chunks = main